import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _trimEndInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim-end';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React from 'react';
import BadgeNewLarge from '../icons/BadgeNewLarge.js';
import { BADGE_TYPE } from '../../constants/global.js';
import styles from './HeaderButton.module.scss.js';

var _excluded = ["href", "badge", "count", "onClick", "children", "className"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function HeaderBadge(_ref) {
  var badge = _ref.badge,
    count = _ref.count;
  if (typeof count === 'number') {
    var countText = count > 99 ? '99+' : "".concat(count);
    return /*#__PURE__*/React.createElement("span", {
      className: cx('badge')
    }, /*#__PURE__*/React.createElement("span", {
      className: cx('count')
    }, countText));
  }
  return /*#__PURE__*/React.createElement("span", {
    className: cx('badge', {
      'type-dot': badge === BADGE_TYPE.DOT
    })
  }, badge === BADGE_TYPE.NEW && /*#__PURE__*/React.createElement(BadgeNewLarge, {
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uC2E0\uADDC"));
}
function HeaderButton(_ref2) {
  var _context;
  var href = _ref2.href,
    badge = _ref2.badge,
    count = _ref2.count,
    onClick = _ref2.onClick,
    children = _ref2.children,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded);
  var buttonClassName = _trimEndInstanceProperty(_context = [cx('article'), className].join(' ')).call(_context);
  return /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, props), {}, {
    href: href,
    className: buttonClassName,
    onClick: onClick
  }), (badge || !!count && count > 0) && /*#__PURE__*/React.createElement(HeaderBadge, {
    badge: badge,
    count: count
  }), children);
}

export { HeaderButton as default };
